import { Button, InlineAlert } from "../../shared/ui";

/**
 * §70's conflict, told plainly.
 *
 * <p>Never a silent retry with the newer version. During a deployment window several people have
 * this release open, and quietly reapplying an edit over somebody else's is how a decision
 * disappears without anybody noticing it happened.
 */
export function ConflictNotice({ onRefresh }: { onRefresh: () => void }) {
  return (
    <InlineAlert tone="warning">
      <p className="font-medium">This release was changed by somebody else.</p>
      <p className="mt-0.5">
        Your copy is out of date. Refresh to see what changed before trying again — nothing has
        been overwritten.
      </p>
      <Button variant="secondary" size="sm" className="mt-2" onClick={onRefresh}>
        Refresh
      </Button>
    </InlineAlert>
  );
}
